import { frontendURL } from '../../../helper/URLHelper';
import CallCenterDashboard from './pages/CallCenterDashboard.vue';

const CALL_CENTER_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/call-center'),
      name: 'call_center_index',
      meta: {
        permissions: CALL_CENTER_PERMISSIONS,
      },
      component: CallCenterDashboard,
    },
  ],
};
